import React, { useRef } from 'react';

import type { CheckboxColumnDefinition } from '@gitbook/doc-core';
import { Icon } from '@gitbook/spine-icons';
import type { CheckboxRef } from '@gitbook/spine-react';
import { Checkbox } from '@gitbook/spine-react';

import type { RecordValueRenderProps, TableDefinitionRenderSpec } from './types';

export const checkboxDefinitionSpec: TableDefinitionRenderSpec<boolean, CheckboxColumnDefinition> =
    {
        title: 'Checkbox',
        description: 'A single checkbox that can be checked or unchecked.',
        icon: Icon.ColumnTypeCheckbox,
        ValueComponent: RecordCheckboxValue,
        onKeyDown: (key, value, setValue) => {
            switch (key) {
                case 'backspace':
                    if (value) {
                        setValue(false);
                    }
                    break;
                case 'space':
                    setValue(!value);
                    break;
            }
        },
    };

/**
 * Cell content for a Checkbox column.
 */
function RecordCheckboxValue(
    props: RecordValueRenderProps<boolean, CheckboxColumnDefinition>
): React.ReactElement {
    const { value, readOnly, onValueChange, onKeyDown, selected } = props;
    const ref = useRef<CheckboxRef>(null);

    React.useEffect(() => {
        // If the current cell is `selected`, focus the checkbox
        selected ? ref.current?.focus() : ref.current?.blur();
    }, [selected]);

    return (
        <div className="flex flex-1 items-center">
            <Checkbox
                value={value}
                ref={ref}
                onChange={onValueChange}
                onKeyDown={onKeyDown}
                readOnly={readOnly}
                slot={null}
            />
        </div>
    );
}
